import LocaleLibrary from "../data/bean/locale/locale_library";
import Config from "../data/constant/config";
import GeneralWebService from "../service/general_web_service";

export default class LanguageBloc {

  //Get either EN or BM based on selected language
  static getEngOrBMText(en, bm) {
      let language = this.getSelectedLanguage();
      if (language == Config.locale.en) {
          return en;
      } else if (language == Config.locale.bm) {          
          return bm;
      } else {
          return en;
      }
  }

  //Get language by dictionary
  static getTextForLocale(dict) {    
    let language = this.getSelectedLanguage();
    if(!dict) return null;   
    let text = dict[language.toLocaleLowerCase()];    
    return text || dict.en;
}

  //Get user latest selected language
  static getSelectedLanguage() {  
    //Issue in here  
    let selectedLanguage = sessionStorage.getItem(Config.cache.languageKey);
    return selectedLanguage ? selectedLanguage : Config.locale.en;
  }

  //Update user last selected language
  static async updateSelectedLanguage(session, lang) {
    sessionStorage.setItem(Config.cache.languageKey, lang);
    let locale = this.getSelectedLanguageForAPI();
    /* if(session.trxId){
      let resp = await GeneralWebService.updateLanguage(session, locale);  
    } */
  }

  //Get selected language for API update
  static getSelectedLanguageForAPI() {
    let selectedLanguage = sessionStorage.getItem(Config.cache.languageKey);
    if (selectedLanguage === Config.locale.bm) return "BM";
    return "EN";
  }

  //Get error title by error code
  static getErrorTitleByCode(errorCode) {
    return this.getTextByCode(Config.labelPrefix.errorTitle + errorCode);
  }

  //Get error desc by error code
  static getErrorDescByCode(errorCode) {
    return this.getTextByCode(Config.labelPrefix.errorDesc + errorCode);
  }

  //use this and remove hardcoded "getTextByCode" function when API label data are populated
  static getTextByCode(code, specificLang) {
    let labels = this.getLabelsByCode(code);
    let lang = specificLang || this.getSelectedLanguage();     
    let text = labels[lang];
    //if(!text) return Config.error.labelNotFound;
    if(!text) return code;          
    return text;
  }

  //Fetch all labels from API
  static async fetchLabelsFromAPI(cache) {      
    let result = await (await GeneralWebService.getMasterDataWithCode("?category=LABEL&code=LABEL")).data;      
    //Check if cache labels is true and there are records
   
    if (cache != false && (result && result.length > 0)) {
      let enLibrary = result[0].extra.en;
      let bmLibrary = result[0].extra.bm;      
      //Storing each labels into their respective library
      
      let localeLibrary = new LocaleLibrary({
        en: enLibrary,
        bm: bmLibrary
      });    
      sessionStorage.setItem(Config.cache.localeKey, JSON.stringify(localeLibrary));
      return localeLibrary;
    }
    
    return null;
  }

  //Fetch all labels from cache
  static fetchLabelsFromCache(){
    let localeCache = sessionStorage.getItem(Config.cache.localeKey);    
    //If locale is not store in cache yet
    if(!localeCache){
      // alert("Error loading labels");
      return {};
    }
    
    let localeLibraryJSON = JSON.parse(localeCache);
    let localeLibrary = new LocaleLibrary(localeLibraryJSON);

    return localeLibrary;
  }

  //Fetch labels from code
  static getLabelsByCode(code){
    let locale = this.fetchLabelsFromCache();
    
    let en = locale.en[code];
    let bm = locale.bm[code];
    let enKey = Config.locale.en;
    let bmKey = Config.locale.bm

    let dict = {};
    dict[enKey] = en;
    dict[bmKey] = bm;
    return dict;
  }

}